import { Collapse, createStyles, Divider, List, ListItem, withStyles } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import classNames from 'classnames';
import React from 'react';
import AppMenuMainItem from '../common/AppDrawerItem';
import { compose } from 'redux';
import { connect } from 'react-redux';

const styles = createStyles(theme => ({
  paragraph: {
    marginLeft: theme.spacing(1),
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    borderLeftColor: theme.palette.divider,
  },
}));

const AppDrawerSimpleList = React.forwardRef(({
                                                classes,
                                                menuDefinition,
                                                paragraph = false,
                                                onClick,
                                                user,
                                              }, ref) => {
  const [submenuOpened, setSubmenuOpened] = React.useState(null);
  const { LicenseInfo: { Version } } = user;
  return (
    <List
      ref={ref}
      classes={{
        root: classNames(paragraph && classes.paragraph),
      }}
    >
      {menuDefinition.map((menuItemDefinition, index) => {
        if ('label' in menuItemDefinition) {
          return (
            <React.Fragment key={menuItemDefinition.labelId}>
              <AppMenuMainItem
                menuItemDefinition={menuItemDefinition}
                isSubmenuOpened={submenuOpened === index}
                SubmenuOpenedIcon={ArrowDropUp}
                SubmenuClosedIcon={ArrowDropDown}
                disabled={menuItemDefinition.disabled || menuItemDefinition.disabledOnMobile}
                onClick={event => {
                  if ('submenu' in menuItemDefinition) {
                    setSubmenuOpened(currentIndex => (currentIndex === index ? null : index));
                  } else {
                    onClick(event);
                  }
                }}
              />
              
              {'submenu' in menuItemDefinition && (
                <Collapse in={submenuOpened === index}>
                  <AppDrawerSimpleList
                    paragraph
                    classes={classes} // manual injection due to recursive usage
                    menuDefinition={menuItemDefinition.submenu}
                    onClick={onClick}
                    user={user}
                  />
                </Collapse>
              )}
            </React.Fragment>
          );
        } else if ('object' in menuItemDefinition) {
          return menuItemDefinition.available?.includes(Version) ?
            <ListItem className={classes.listItemStyles} key={index}>
              {menuItemDefinition.object}
            </ListItem>
            : null;
        }
        return (
          <Divider key={menuItemDefinition.key} />
        );
      })}
    
    </List>
  );
});

const decorate = compose(withStyles(styles),
  connect(store => ({ user: store.user.profile })));
export default decorate(AppDrawerSimpleList);